module.exports = __webpack_public_path__ + "static/media/print.a35b1842.svg";